import { useAppDispatch, useTypedSelector } from "@/config/configureAppStore";
import { MIXPANEL_EVENTS } from "@/constants/mixpanel";
import { isInternalUserPolicy, usePermissions } from "@/features/permissions";
import { userStateApi } from "@/features/userState/api";
import { setCreateProjectDialog } from "@/reducers/slices/dialogSlice/dialogSlice";
import { setStartFlowCompleted } from "@/reducers/slices/userSlice/userSlice";
import { trackMixpanelEvent } from "@/utils/mixpanel";
import { START_FLOW_COMPLETED, storageService } from "@/utils/storage";
import { trackUserFlowEvent } from "@/utils/userflow";
import { useEffect, useRef } from "react";

const useStartFlow = () => {
  const dispatch = useAppDispatch();
  const startFlowCompleted = useTypedSelector(
    (state) => state.user.startFlowCompleted
  );
  const pricingDialogOpen = useTypedSelector(
    (state) => state.pricingDialog.open
  );
  const isCreateProjectDialogOpen = useTypedSelector(
    (state) => state.dialog.createProjectDialog?.open
  );

  const isCreateProjectDialogOpenRef = useRef(isCreateProjectDialogOpen);

  const { canAccess } = usePermissions();

  const isInternalUser = canAccess({
    policy: isInternalUserPolicy,
    policyArgs: null
  });

  const closeStartFlow = () => {
    dispatch(setStartFlowCompleted(true));
  };

  const completeStartFlow = () => {
    userStateApi.completeStartFlow().catch(() => {
      storageService.setItem(START_FLOW_COMPLETED, "true");
    });
  };

  useEffect(() => {
    const shouldShowPricingDialog = storageService.getItem("showPricingDialog");
    if (
      !startFlowCompleted &&
      !isInternalUser &&
      !shouldShowPricingDialog &&
      !pricingDialogOpen
    ) {
      if (!isCreateProjectDialogOpenRef.current) {
        trackMixpanelEvent(MIXPANEL_EVENTS.CREATE_PROJECT_START, {
          "Entry Point": "FTUX"
        });
        trackUserFlowEvent(MIXPANEL_EVENTS.CREATE_PROJECT_START, {});
        dispatch(setCreateProjectDialog(true));
        isCreateProjectDialogOpenRef.current = true;
      }
    }
  }, [startFlowCompleted, dispatch, isInternalUser, pricingDialogOpen]);

  return {
    startFlowCompleted,
    closeStartFlow,
    completeStartFlow
  };
};

export default useStartFlow;
